import React, { useMemo } from 'react';
import type { GroupChannel } from '@sendbird/chat/groupChannel';

import Avatar from 'src/components/ui/Avatar';
import type { Props as AvatarProps } from 'src/components/ui/Avatar';
import { colours } from 'src/constants/colours';

interface Props {
    channel: GroupChannel;
    dataTargetId?: string;
    size: number;
}

const GroupConversationAvatar = ({ channel, dataTargetId, size }: Props) => {
    const avatarProps: Pick<AvatarProps, 'iconName' | 'image'> = useMemo(() => {
        // Sendbird set a default cover on channel creation
        const hasCoverUrl = channel.coverUrl && !channel.coverUrl.includes('sendbird.com/sample');

        return {
            alt: channel.name,
            image: hasCoverUrl ? { url: channel.coverUrl } : undefined,
            iconName: hasCoverUrl ? undefined : 'UserGroup',
            iconColor: colours.white.main,
        };
    }, [channel]);

    return <Avatar alt={channel.name} data-target-id={dataTargetId} size={size} {...avatarProps} />;
};

export default GroupConversationAvatar;
